// removed by extract-text-webpack-plugin
module.exports = {"root":"_3KpwC","small":"Eh89_","medium":"_1szFn","large":"_16Bje"};


//////////////////
// WEBPACK FOOTER
// ../source/layouts/Container/styles.css
// module id = 1166
// module chunks = 26